
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/healers/[slug]/detail",
      function () {
        return require("private-next-pages/healers/[slug]/detail.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/healers/[slug]/detail"])
      });
    }
  